import { POP as pop } from '@/http-common'
import { POM as api } from '@/http-common'
import CannotFindButton from '../../modules/cannot-find-button/cannot-find-button'

export default {
    name: 'order-page',
    components: { CannotFindButton },
    props: ['productId', 'orderId'],
    data() {
        return {
            loading: 0,
            product: null,
            order: null,
            orderError: null,
            availableSpecification: { documentSize: [], extent: [], orientation: [], stockWeight: [], lamination: [] },
            specification: { documentSize: null, extent: null, orientation: null, stockWeight: null, lamination: null },
            specificationId: 0,
            quantity: 0,
            // artwork: false,
            artwork: 0,
            chosenArtwork: null,
            invalidQuantity: false,
            resettingQuantity: false,
            popSpecification: null,
            price: 0,
            design: { spec: 0, item: 0, price: 35, loading: false },
            carriage: { spec: 0, item: 0, price: 6, loading: false },
            carouselIndex: 0,
            priceTable: [
                { quantity: 1, price: 0, loading: false },
                { quantity: 2, price: 0, loading: false },
                { quantity: 5, price: 0, loading: false },
                { quantity: 10, price: 0, loading: false },
                { quantity: 20, price: 0, loading: false },
                { quantity: 50, price: 0, loading: false },
                { quantity: 100, price: 0, loading: false },
                { quantity: 200, price: 0, loading: false },
                { quantity: 500, price: 0, loading: false },
                { quantity: 1000, price: 0, loading: false },
                { quantity: 2000, price: 0, loading: false },
                { quantity: 5000, price: 0, loading: false },
                { quantity: 10000, price: 0, loading: false },
                { quantity: 20000, price: 0, loading: false },
                { quantity: 50000, price: 0, loading: false },
                { quantity: 100000, price: 0, loading: false },
                { quantity: 200000, price: 0, loading: false },
                { quantity: 500000, price: 0, loading: false },
                { quantity: 1000000, price: 0, loading: false }
            ],
        }
    },
    computed: {
        canOrder() {
            return (this.artwork != 2 || this.chosenArtwork) ? (this.loading <= 0 && this.price > 0) : false
        },
        finalPrice() {
            return this.calculatedPrice(this.price, this.quantity)
        },
        images() {
            return this.product ? JSON.parse(this.product.images) : [];
        }
    },
    methods: {
        fetchProduct() {
            this.loading++
            this.resetProduct()
            api.get('product/' + this.productId).then(response => {
                this.loading--
                this.product = response.data
                this.fetchSpecificationOptions('documentSize', true)
                if (this.orderId) {
                    this.fetchOrder()
                } else {
                    this.loadProductSpecification()
                }
            }).catch(error => {
                this.loading--
            })
        },
        fetchOrder() {
            if (!this.orderId) { return }
            this.loading++
            api.get('basket/order/' + this.orderId).then(response => {
                this.loading--
                this.order = response.data
                this.chosenArtwork = { image: this.order.specification.design }
                this.loadProductSpecification()
            }).catch(error => {
                this.loading--
            })
        },
        loadProductSpecification() {
            if (this.order) {
                this.specification = this.order.specification
                this.quantity = this.order.quantity
                this.artwork = this.order.specification.artwork
            } else if (this.product.alias == 'Brochure') {
                this.specification = { documentSize: 'A4', extent: 12, orientation: 'Portrait', stockWeight: 170, lamination: 'None' }
                this.quantity = 500
            } else if (this.product.alias == 'Folders') {
                this.specification = { documentSize: '300x215x5', extent: 4, orientation: 'Portrait', stockWeight: 350, lamination: 'Matt' }
                this.quantity = 500
            } else if (this.product.alias == 'Canvassing') {
                this.specification = { documentSize: 'A5', extent: 2, orientation: 'Landscape', stockWeight: 300, lamination: 'None' }
                this.quantity = 5000
            } else if (this.product.alias == 'Minimags') {
                this.specification = { documentSize: 'A5', extent: 4, orientation: 'Landscape', stockWeight: 150, lamination: 'None' }
                this.quantity = 5000
            } else if (this.product.alias == 'Leaflets & Folded Cards') {
                this.specification = { documentSize: 'A4', extent: 2, orientation: 'Portrait', stockWeight: 170, lamination: 'None' }
                this.quantity = 250;
            }
        },
        fetchSpecificationOptions(option, fetchNext = true) {
            let params = {
                description: this.product.alias,
                output: option
            }
            let nextOption = null
            if (option == 'documentSize') {
                nextOption = 'extent'
            } else if (option == 'extent') {
                nextOption = 'orientation'
                params['documentSize'] = this.specification.documentSize
            } else if (option == 'orientation') {
                nextOption = 'stockWeight'
                params['documentSize'] = this.specification.documentSize
                params['extent'] = this.specification.extent
            } else if (option == 'stockWeight') {
                nextOption = 'lamination'
                params['documentSize'] = this.specification.documentSize
                params['extent'] = this.specification.extent
                params['orientation'] = this.specification.orientation
            } else if (option == 'lamination') {
                params['documentSize'] = this.specification.documentSize
                params['extent'] = this.specification.extent
                params['orientation'] = this.specification.orientation
                params['stockWeight'] = this.specification.stockWeight
            }
            this.loading++
            pop.get('specification', { params: params }).then(response => {
                this.loading--
                this.$set(this.availableSpecification, option, response.data.results)
                if (response.data.results.length == 1) {
                    this.$set(this.specification, option, response.data.results[0])
                }
                if (fetchNext && nextOption) {
                    this.fetchSpecificationOptions(nextOption, fetchNext)
                }
            }).catch(error => {
                this.loading--
            })
        },
        fetchPopSpecification(callback) {
            let params = {
                description: this.product.alias,
                documentSize: this.specification.documentSize,
                extent: this.specification.extent,
                orientation: this.specification.orientation,
                stockWeight: this.specification.stockWeight,
                lamination: this.specification.lamination
            }
            this.loading++
            pop.get('specification', { params: params }).then(response => {
                this.loading--
                // we're always pulling the first specification provided by POP
                // this may not be accurate but at this moment there is no
                // way to determine which specification is required
                this.popSpecification = response.data.results[0]
                this.specificationId = this.popSpecification.specificationId
                if (callback) {
                    callback(true, response)
                }
            }).catch(error => {
                this.loading--
                if (callback) {
                    callback(false, error)
                }
            })
        },
        fetchPrice(quantity, callback) {
            if (!this.popSpecification || quantity == 0) {
                return
            }
            let params = {
                specificationId: this.popSpecification.specificationId,
                itemId: this.popSpecification.itemId,
                quantity: quantity
            }
            pop.get('price', { params: params }).then(response => {
                let price = parseFloat(response.data.results.totalPrice || 0)
                callback(true, price, response)
            }).catch(error => {
                callback(false, 0, error)
            })
        },
        fetchPriceTable() {
            this.priceTable.forEach(entry => {
                if (!this.shouldFetchEntryPrice(entry)) {
                    entry.price = 0
                    entry.loading = false
                } else if (entry.quantity == this.quantity && this.price > 0) {
                    entry.price = this.price
                    entry.loading = false
                } else {
                    entry.loading = true
                    this.fetchPrice(entry.quantity, (success, price, response) => {
                        entry.price = price
                        entry.loading = false
                        if (response && response.data.results.minimumQuantity) { this.$set(this.availableSpecification, 'min', response.data.results.minimumQuantity) }
                        if (response && response.data.results.maximumQuantity) { this.$set(this.availableSpecification, 'max', response.data.results.maximumQuantity) }
                        // this.updateQuantity()
                    })
                }
            })
        },
        priceFetched(price, response) {
            if (response.data && response.data.results && response.data.results.specificationId) {
                this.specificationId = response.data.results.specificationId
            }
            this.price = price
            if (response && response.data.results.minimumQuantity) { this.$set(this.availableSpecification, 'min', response.data.results.minimumQuantity) }
            if (response && response.data.results.maximumQuantity) { this.$set(this.availableSpecification, 'max', response.data.results.maximumQuantity) }
            if (price == 0 || response.data.error) {
                this.invalidQuantity = true
                this.updateQuantity()
            }
        },
        fetchArtworkPrice() {
            this.design.loading = true
            // fetch the artwork specification
            let params = {
                jobMethod: 'Artwork',
                description: this.product.alias,
                documentSize: this.specification.documentSize,
                extent: this.popSpecification.data.totalExtent,
                orientation: this.specification.orientation
            }
            pop.get('specification', { params: params }).then(response => {
                if (!response.data.results) {
                    this.design = { spec: 0, item: 0, price: 35, loading: false }
                    return
                }
                let spec = response.data.results[0];
                this.design.spec = spec.specificationId
                this.design.item = spec.itemId
                let params = { specificationId: spec.specificationId, itemId: spec.itemId, quantity: 1 }
                pop.get('price', { params: params }).then(response => {
                    console.log('design price', response.data)
                    this.design.price = parseFloat(response.data.results.totalPrice || 35)
                    this.design.loading = false
                }).catch(error => {
                    this.design = { spec: 0, item: 0, price: 35, loading: false }
                })
            }).catch(error => {
                this.design = { spec: 0, item: 0, price: 35, loading: false }
            })
        },
        fetchCarriagePrice() {
            this.carriage.loading = true
            // fetch the carriage specification
            let params = { type: 'Delivery', category: this.product.alias }
            pop.get('specification', { params: params }).then(response => {
                if (!response.data.results) {
                    this.carriage = { spec: 0, item: 0, price: 35, loading: false }
                    return
                }
                response.data.results.forEach(spec => {
                    if (spec.data.deliveryHours == 72) {
                        this.carriage.spec = spec.specificationId
                        this.carriage.item = spec.itemId
                        let params = { specificationId: spec.specificationId, itemId: spec.itemId, quantity: 1 }
                        pop.get('price', { params: params }).then(response => {
                            console.log('carriage price', response.data)
                            this.carriage.price = parseFloat(response.data.results.totalPrice || 6)
                            this.carriage.loading = false
                        }).catch(error => {
                            console.log('Failed to get carriage price', error)
                            this.carriage = { spec: 0, item: 0, price: 6, loading: false }
                        })
                    }
                })
            }).catch(error => {
                this.carriage = { spec: 0, item: 0, price: 6, loading: false }
            })
        },
        createOrder() {
            this.placeOrder(this.finalPrice, this.quantity)
        },
        updateOrder() {
            this.changeOrder(this.finalPrice, this.quantity)
        },
        changeOrder(price, quantity) {
            let params = {
                product_id: this.productId, quantity: quantity, price: price, design_fee: this.design.price,
                specification_id: this.popSpecification.specificationId, design_specification_id: this.design.spec,
                specification: {
                    documentSize: this.specification.documentSize,
                    extent: this.specification.extent,
                    orientation: this.specification.orientation,
                    stockWeight: this.specification.stockWeight,
                    lamination: this.specification.lamination,
                    delivery: this.hasCarriage(),
                    artwork: this.artwork,
                    design: this.artwork == 2 && this.chosenArtwork ? this.chosenArtwork.image : null
                },
                design_specification: {
                    jobMethod: 'Artwork',
                    documentSize: this.specification.documentSize,
                    extent: this.popSpecification.data.totalExtent,
                    orientation: this.specification.orientation
                },
            }
            this.loading++
            api.patch('basket/order/' + this.orderId, params).then(response => {
                this.loading--
                if (response.data.error) {
                    // TODO: show order error
                    return
                }
                this.$router.push('/basket');
            }).catch(error => {
                // TODO: show order error
                this.loading--
            })
        },
        placeOrder(price, quantity) {
            let params = {
                product_id: this.productId, quantity: quantity, price: price, design_fee: this.design.price,
                specification_id: this.specificationId, design_specification_id: this.design.spec,
                delivery_specification_id: this.carriage.spec, delivery_item: this.carriage.item,
                specification: {
                    documentSize: this.specification.documentSize,
                    extent: this.specification.extent,
                    orientation: this.specification.orientation,
                    stockWeight: this.specification.stockWeight,
                    lamination: this.specification.lamination,
                    delivery: this.hasCarriage(),
                    artwork: this.artwork,
                    design: this.artwork == 2 && this.chosenArtwork ? this.chosenArtwork.image : null
                },
                design_specification: {
                    jobMethod: 'Artwork',
                    documentSize: this.specification.documentSize,
                    extent: this.popSpecification.data.totalExtent,
                    orientation: this.specification.orientation
                }
            }
            this.loading++
            api.post('basket/add', params).then(response => {
                this.loading--
                if (response.data.error) {
                    // TODO: show order error
                    return
                }
                this.$router.push('/basket');
            }).catch(error => {
                // TODO: show order error
                this.loading--
            })
        },
        // delayed
        fetchPopSpecificationDelayed: _.debounce(function (callback) {
            return this.fetchPopSpecification(callback)
        }, 1500),
        fetchPriceDelayed: _.debounce(function (quantity, callback) {
            return this.fetchPrice(quantity, callback)
        }, 750),
        fetchArtworkPriceDelayed: _.debounce(function () {
            return this.fetchArtworkPrice()
        }, 750),
        fetchCarriagePriceDelayed: _.debounce(function () {
            return this.fetchCarriagePrice()
        }, 750),
        // helpers
        hasCarriage(quantity) {
            if (this.product.alias == 'Canvassing') {
                return quantity < 3000;
            } else if (this.product.alias == 'Minimags') {
                return quantity < 3000;
            } else if (this.product.alias == 'Brochure') {
                return false;
            } else if (this.product.alias == 'Folders') {
                return false;
            } else if (this.product.alias == 'Leaflets & Folded Cards') {
                return quantity < 3000;
            } else {
                return false
            }
        },
        calculatedPrice(price, quantity) {
            if (price <= 0) { return price }
            if (this.hasCarriage(quantity)) { price += this.carriage.price }
            if (this.artwork == 1 || this.artwork == 2) { price += this.design.price }
            return price
        },
        resetProduct() {
            this.price = 0
            this.order = null
            this.invalidQuantity = false
            this.resettingQuantity = false
            this.availableSpecification = { documentSize: [], extent: [], orientation: [], stockWeight: [], lamination: [] }
            this.popSpecification = null
            this.carouselIndex = 0
            this.chosenArtwork = null
            $('#carousel').carousel(0)
        },
        shouldFetchEntryPrice(entry) {
            if (this.availableSpecification.min && this.availableSpecification.max) {
                return entry.quantity > this.availableSpecification.min && entry.quantity < this.availableSpecification.max
            }
            return true
        },
        findClosestQuantity(quantity) {
            let closest = 0
            let previous = null
            this.priceTable.filter(entry => entry.price > 0).forEach((entry, index) => {
                let diff = entry.quantity - quantity
                // ensure the value is positive
                if (diff < 0) diff *= -1
                if (previous == null || diff <= previous) {
                    previous = diff
                    closest = entry.quantity
                }
            })
            return closest;
        },
        updateQuantity() {
            if (this.price > 0) { return }
            // check the quantity, adjust if needed
            this.resettingQuantity = true
            if (this.availableSpecification.min && this.availableSpecification.min > this.quantity) {
                this.quantity = this.availableSpecification.min
            } else if (this.availableSpecification.max && this.availableSpecification.max < this.quantity) {
                this.quantity = this.availableSpecification.max
            } else {
                let entry = this.findClosestQuantity(this.quantity)
                if (entry > 0) {
                    this.quantity = entry
                } else {
                    this.invalidQuantity = true
                }
            }
        },
        resetInvalidQuantity() {
            this.invalidQuantity = false
        },
        goToCarouselImage(index) {
            this.carouselIndex = index;
            $('#carousel').carousel(index);
        },
        designSelected(design) {
            this.chosenArtwork = design
        }
    },
    watch: {
        $route() {
            this.fetchProduct()
            // this.fetchOrder()
        },
        loading(newVal) {
            if (newVal < 0) { this.loading = 0 }
        },
        specification: {
            handler() {
                this.invalidQuantity = false
                this.price = 0
                this.availableSpecification.min = null
                this.availableSpecification.max = null
                this.priceTable.forEach(entry => {
                    entry.loading = true
                    entry.price = 0
                })
                this.fetchPopSpecificationDelayed((success, data) => {
                    if (success) {
                        // this.priceTable.forEach(entry => entry.loading = true)
                        this.fetchPrice(this.quantity, (success, price, response) => {
                            this.priceFetched(price, response)
                            this.fetchPriceTable()
                        })
                        this.fetchArtworkPrice()
                    }
                })
                this.fetchCarriagePriceDelayed()
            },
            deep: true
        },
        quantity() {
            if (!this.resettingQuantity) {
                this.invalidQuantity = false
            }
            this.price = 0
            this.fetchPriceDelayed(this.quantity, (success, price, response) => {
                this.priceFetched(price, response)
            })
            this.resettingQuantity = false
        },
    },
    created() {
        this.fetchProduct()
        // this.fetchOrder()
        this.$root.$on('design::selected', this.designSelected)
    },
    mounted() {
        let component = this;
        window.setTimeout(function () {
            $('#carousel').on('slide.bs.carousel', function (e) {
                component.carouselIndex = e.to;
            });
        }, 1000)
    },
    beforeDestroy() {
        this.$root.$off('design::selected', this.designSelected)
    },
}


// WEBPACK FOOTER //
// ./src/components/pages/order/order-new.js